import { render, staticRenderFns } from "./FeaturesList.vue?vue&type=template&id=b534bad8&scoped=true&"
import script from "./FeaturesList.vue?vue&type=script&lang=js&"
export * from "./FeaturesList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesList.vue?vue&type=style&index=0&id=b534bad8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b534bad8",
  null
  
)

export default component.exports